import { render, staticRenderFns } from "./SigDefResponses.vue?vue&type=template&id=11bf5955&scoped=true"
import script from "./SigDefResponses.vue?vue&type=script&lang=js"
export * from "./SigDefResponses.vue?vue&type=script&lang=js"
import style0 from "./SigDefResponses.vue?vue&type=style&index=0&id=11bf5955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf5955",
  null
  
)

export default component.exports